import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';
import { Event } from '../../../types/Event';
import { AxiosError } from 'axios';

export interface DuplicateEventPayload {
  name: string;
  start_at: string;
  copy_options: {
    employees: boolean;
    contacts: boolean;
    attachments: boolean;
  };
}

const duplicateEventRequest = async (uuid: string, payload: DuplicateEventPayload) => {
  const response = await CustomAxios.post(`/events/${uuid}/duplicate`, payload);
  return response.data as Event;
};

export function useDuplicateEvent({ uuid, onSuccess }: { uuid: string; onSuccess: (event: Event) => void }) {
  return useMutation({
    mutationKey: [mutationKeys.duplicateEvent, uuid],
    mutationFn: (payload: DuplicateEventPayload) => duplicateEventRequest(uuid, payload),
    onSuccess: (newEvent: Event) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, uuid] });
      onSuccess(newEvent);
    },
    onError: (err: AxiosError) => {
      console.error('Duplicate event failed', err);
    },
  });
}
